import Animation from "./Animation";
import { gsap, Sine } from "gsap";

/**
 * A custom element class for accessing window events and associated callbacks for animations
 * @extends Animation
 * @property {Function} animate the animation this class will run
 * @property {Function} setDefault set defaults for animation or element
 * @property {Function} onViewportExit a callback function for intersection observer exit
 */
class StaggerFade extends Animation {

	/**
	 * Runs the animation
	 * @param {function} done animation complete callback, passed into run()
	 */
	animate({ done }) {

		gsap.to(this.animEls, {
			opacity: 1,
			delay: 0.3,
			duration: 0.5,
			ease: "Power2.inOut",
			stagger: 0.15,
			onComplete: done
		});
	}

	/**
	 * Will fire when element binds to the DOM, use this to
	 * set up default states if needed
	 */
	setDefault() {

		this.animEls = this.element.querySelectorAll(".js-stagger");

		/** --- Start hidden --- */
		gsap.set(this.animEls, {
			opacity: 0
		});
	}

	/**
	 * Intersection Observer callback, only needs to fire this.run()
	 * this.run() can contain a callback function for done()
	 */
	onViewportEnter() {


		this.run(() => {
		});
	}
}

export default StaggerFade;
